import React, { Dispatch, SetStateAction } from 'react'
import { Checkbox as SberCheckbox } from 'ui-kit-sber/dist/js/components/Checkbox'
import { CheckboxProps as SberCheckboxProps } from 'antd/es/checkbox'
import styled from 'styled-components'

import { r } from '@utils/styles/functions'
import checkedIcon from '@icons/checkbox.svg'

export interface ICheckboxProps extends SberCheckboxProps {
  state?: [boolean, Dispatch<SetStateAction<boolean>>]
  value?: boolean
  isRound?: boolean
  onChange?: (e: any) => void
  label?: string
}

const CheckboxModified: React.FC<ICheckboxProps> = ({ state, value, onChange, label, children, ...props }) => {
  return (
    <SberCheckbox
      {...(typeof value !== 'undefined'
        ? {
            checked: value,
            value,
          }
        : {})}
      {...(onChange
        ? {
            onChange: (e) => onChange(e.target.checked),
          }
        : {})}
      {...(state ? { checked: state[0], onChange: () => state[1]((prev: boolean) => !prev) } : {})}
      {...props}
    >
      {label ?? children ?? ''}
    </SberCheckbox>
  )
}

const Checkbox = styled(CheckboxModified)`
  &.ant-checkbox-wrapper:hover .ant-checkbox-inner,
  &.ant-checkbox:hover .ant-checkbox-inner,
  &.ant-checkbox-input:focus + .ant-checkbox-inner {
    border-color: ${(props) => props.theme.colors.green};
  }

  &.ant-checkbox-wrapper {
    display: inline-flex;
    align-items: flex-start;
    color: ${(props) => props.theme.colors.graphite};
    & + .ant-checkbox-wrapper {
      margin-left: ${(props) => (props.isRound ? '0' : '8px')};
    }

    & > span:last-child {
      margin-top: ${r(2)};
      margin-left: ${r(16)};
      color: ${(props) => props.theme.colors.graphite};
      white-space: pre-line;

      p:not(:last-child) {
        margin-bottom: ${r(7)};
      }

      p:last-child {
        margin-bottom: 0;
      }
    }

    &-disabled {
      opacity: 0.7;
    }
  }

  .ant-checkbox {
    &-checked::after {
      border: ${(props) => (props.isRound ? 'none' : `1px solid ${props.theme.colors.green}`)};
    }
    &-disabled {
      & + span {
        color: ${(props) => props.theme.colors.graphite};
      }
      .ant-checkbox-inner {
        border-color: ${(props) => props.theme.colors.lightGray}!important;
        background: ${(props) => (props.isRound ? props.theme.colors.middleGray : props.theme.colors.lightGray)};
      }
    }
    &-checked.ant-checkbox-disabled {
      .ant-checkbox-inner {
        border-color: ${(props) => props.theme.colors.green}!important;
      }
    }

    + span {
      padding-left: 0;
      padding-right: 0;
    }

    &-inner {
      width: 24px;
      height: 24px;
      max-width: 24px;
      max-height: 24px;
      flex-grow: 0;
      border-radius: ${(props) => (props.isRound ? '50%' : '2px')};

      &::after {
        background: url(${checkedIcon}) no-repeat !important;
        width: ${r(12)} !important;
        height: ${r(9)} !important;
        top: 50% !important;
        left: 50% !important;
        transform: translate(-50%, -50%) !important;
      }
    }
  }
`

Checkbox.displayName = 'Checkbox'

export default Checkbox
